/* eslint-disable @typescript-eslint/no-unused-vars */
import { SupabaseClient, Provider, User } from '@supabase/supabase-js';
import { SupabaseCore } from '../supabase/supabase-core';

export abstract class AuthCore {
  readonly ROLE_SUPERADMIN = 'superadmin';
  readonly ROLE_ADMIN = 'admin';

  protected supabaseService: SupabaseCore;

  constructor(supabaseService: SupabaseCore) {
    this.supabaseService = supabaseService;
  }

  protected getSupabase(): SupabaseClient {
    return this.supabaseService.getClient();
  }

  // ---- Auth Methods ----
  async signUp(credentials: { email: string; password: string, name?: string }) {
    console.log('Signing up with credentials:', credentials.email, credentials.password, credentials.name);
    const supabase = this.getSupabase();
    if (!supabase) throw new Error('Supabase client is not initialized.');

    // return supabase.auth.signUp(credentials);

    const { data, error } = await supabase.auth.signUp(credentials);
    console.log('Sign up result:', data, error);
    if (error) throw error;
    return data;
  }

  async signIn(email: string, password: string) {
    const supabase = this.getSupabase();
    if (!supabase) throw new Error('Supabase client is not initialized.');

    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) throw error;
    return data;
  }

  async signInWithProvider(provider: Provider) {
    const supabase = this.getSupabase();
    if (!supabase) throw new Error('Supabase client is not initialized.');

    // Explicitly set the redirect URL to work in dev mode
    const redirectTo = `${window.location.origin}/auth/v1/callback`;

    const { data, error } = await supabase.auth.signInWithOAuth({
      provider,
      options: {
        redirectTo: redirectTo, // for dev its localhost we need to redirect to
      },
    });

    // const { data, error } = await supabase.auth.signInWithOAuth({ provider });
    if (error) throw error;
    return data;
  }

  async signOut() {
    const supabase = this.getSupabase();
    if (!supabase) throw new Error('Supabase client is not initialized.');

    await supabase.auth.signOut();
  }

  async sendPasswordReset(email: string, redirectTo?: string) {
    const supabase = this.getSupabase();
    if (!supabase) throw new Error('Supabase client is not initialized.');

    const { data, error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo });
    if (error) throw error;

    return data;
  }

  async updateUserPass(password: string) {
    const supabase = this.getSupabase();
    if (!supabase) throw new Error('Supabase client is not initialized.');

    return supabase.auth.updateUser({ password: password });
    // const { data, error } = await supabase.auth.updateUser({ password: password });
    // if (error) throw error;
    
    // return { data, error };
  }

  async signInWithEmail(email: string) {
    const supabase = this.getSupabase();
    if (!supabase) throw new Error('Supabase client is not initialized.');

    return supabase.auth.signInWithOtp({ email });
  }
}
